"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constant = require("./constant");
/* eslint-disable consistent-return */


var PassengerSelectionStepperUtils = {
  isNumeric: function isNumeric(num) {
    return !Number.isNaN(+num);
  },
  getTotalPassengerCount: function getTotalPassengerCount(paxCount) {
    return Object.values(paxCount).reduce(function (a, b) {
      return a + b;
    });
  },
  getOtherPassengersCount: function getOtherPassengersCount(paxCount, type) {
    var otherPaxTypes = Object.keys(paxCount).filter(function (paxType) {
      return paxType !== type;
    });
    var total = 0;
    otherPaxTypes.forEach(function (paxType) {
      total += paxCount[paxType];
    });
    return total;
  },
  getMinPassengerCount: function getMinPassengerCount(data, paxCount, type) {
    var totalPaxCount = PassengerSelectionStepperUtils.getTotalPassengerCount(paxCount);
    var otherPassengerCount = PassengerSelectionStepperUtils.getOtherPassengersCount(paxCount, type); // if total pax count is equal to min then return current pax count as is

    if (totalPaxCount === data.min) return paxCount[type];

    if (type === _constant.PASSENGER_TYPE.ADULT) {
      // if total pax count is less than min, then assign remaining min count to adult
      if (data.min && totalPaxCount < data.min) return data.min - otherPassengerCount; // adult count will always be 1 if infant count is 0

      if (_constant.PASSENGER_TYPE.INFANT in paxCount && +paxCount[_constant.PASSENGER_TYPE.INFANT] === 0) {
        return 1;
      }
    }

    if (PassengerSelectionStepperUtils.isNumeric(data[type].min)) {
      return +data[type].min;
    }
    /**
     * handle relative pax count
     * Example: adult: {
     *      min:'infant'
     *    }
     * if infant count is 2, then min count for adult is 2
     */


    var relativePaxCount;

    if (data[type].min in data) {
      relativePaxCount = paxCount[data[type].min];
      if (data.min) return Math.max(relativePaxCount, data.min - PassengerSelectionStepperUtils.getOtherPassengersCount(paxCount, type));
      return relativePaxCount;
    }
  },
  getMaxPassengerCount: function getMaxPassengerCount(data, paxCount, type) {
    if (data[type]) {
      if (data[type].max == null || data[type].max === '') return data.max ? data.max - PassengerSelectionStepperUtils.getOtherPassengersCount(paxCount, type) : undefined;

      if (PassengerSelectionStepperUtils.isNumeric(data[type].max)) {
        return +data[type].max;
      }

      var relativePaxCount = paxCount[data[type].max];

      if (data.max) {
        return PassengerSelectionStepperUtils.getTotalPassengerCount(paxCount) === data.max ? paxCount[type] : Math.min(relativePaxCount, data.max - relativePaxCount);
      }

      return relativePaxCount;
    }
  }
};
var _default = PassengerSelectionStepperUtils;
exports.default = _default;